module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 var fieldClass = "icarus-field" ;
__p += '\n';
 fieldClass += ' field-' + field.name ;
__p += '\n';
 fieldClass += field.label_position === 'TOP' || field.label_position === 'BOTTOM' ? " label-vertical" : " label-horizontal" ;
__p += '\n';
 fieldClass += !field.is_visible || field.input_type === 'HIDDEN' ? " hidden" : "" ;
__p += '\n';
 fieldClass += validationStatus === 'error' ? " error" : "" ;
__p += '\n';
 fieldClass += validationStatus === 'validated' ? " success" : "" ;
__p += '\n';
 fieldClass += field.validation_rule === 'REQUIRED' ? " required" : "" ;
__p += '\n<div class="' +
((__t = ( fieldClass )) == null ? '' : __t) +
'"';
 if (fieldLayout) { ;
__p += ' style="' +
((__t = ( "top:" + fieldLayout.top + "px;left:" + fieldLayout.left + "px;width:" + fieldLayout.width + "px;height:" + fieldLayout.height + "px;" )) == null ? '' : __t) +
'"';
 };
__p += ' data-field-id="' +
((__t = ( field.id )) == null ? '' : __t) +
'">\n    ';
 if (field.label && (field.label_position === 'TOP' || field.label_position === 'LEFT')) { ;
__p += '\n    <label for="' +
((__t = ( field.name )) == null ? '' : __t) +
'">' +
((__t = ( field.label )) == null ? '' : __t) +
'</label>\n    ';
 } ;
__p += '\n\n    ' +
((__t = ( control({ inputType: field.input_type, name: field.name, value: getFieldValue(), placeholder: field.placeholder, choices: field.value_choices }) )) == null ? '' : __t) +
'\n\n    ';
 if (field.label && (field.label_position === 'BOTTOM' || field.label_position === 'RIGHT')) { ;
__p += '\n    <label for="' +
((__t = ( field.name )) == null ? '' : __t) +
'">' +
((__t = ( field.label )) == null ? '' : __t) +
'</label>\n    ';
 } ;
__p += '\n\n    ';
 if (error) { ;
__p += '\n    <div class="icarus-field-error">\n        <span>' +
((__t = ( error )) == null ? '' : __t) +
'</span>\n    </div>\n    ';
 } ;
__p += '\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./~/icarus-forms/module/js/templates/field.ejs
// module id = 204
// module chunks = 2 3